/**
 * RebookingChain — the right-rail card that traverses a booking's rebooking
 * lineage. A booking may have a predecessor (`rebookedFrom` — the record it was
 * rebooked FROM) and/or a successor (`rebookedTo` — the record that superseded
 * it). Each neighbour links to its own `/admin/bookings/:id` by the ops UUID, so the
 * chain is walkable hop-by-hop (the detail page re-fetches on the id param).
 *
 * Renders nothing when there is no chain on either side.
 */
import type { BookingChain } from '../../api/bookingsV2';

import RebookingChainRow from './components/RebookingChainRow';

const cardCls =
  'bg-white dark:bg-[#1e2521] rounded-xl border border-stone-200 dark:border-stone-700';

export function RebookingChain({ chain }: { chain: BookingChain }) {
  if (!chain.rebookedFrom && !chain.rebookedTo) return null;
  return (
    <div className={cardCls}>
      <div className="px-5 py-4 border-b border-stone-200 dark:border-stone-700">
        <h2 className="text-sm font-semibold text-bark-900 dark:text-stone-100">Rebooking</h2>
      </div>
      <div className="p-4 space-y-2.5">
        {chain.rebookedFrom && <RebookingChainRow direction="from" link={chain.rebookedFrom} />}
        {chain.rebookedTo && <RebookingChainRow direction="to" link={chain.rebookedTo} />}
      </div>
    </div>
  );
}
